var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEnvelope(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 510,
    height: 510,
    viewBox: "0 0 510 510",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M437.143 0H72.8571C32.5922 0 0 32.5922 0 72.8571V437.143C0 477.419 32.5808 510 72.8571 510H437.143C477.419 510 510 477.419 510 437.143V72.8571C510 32.5922 477.442 0 437.143 0ZM437.143 346.071C437.143 366.187 420.83 382.5 400.714 382.5H109.286C89.1703 382.5 72.8571 366.187 72.8571 346.071V220.734L230.525 299.591C238.266 303.382 246.576 305.317 255 305.317C263.424 305.317 271.791 303.395 279.441 299.572L437.143 220.734V346.071ZM437.143 179.98L263.196 266.976C258.074 269.537 252.027 269.537 246.906 266.976L72.8571 179.98V163.929C72.8571 143.813 89.1703 127.5 109.286 127.5H400.714C420.83 127.5 437.143 143.813 437.143 163.929V179.98Z",
    fill: "#13293D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M437.143 179.98L263.196 266.976C258.074 269.537 252.027 269.537 246.906 266.976L72.8571 179.98V163.929C72.8571 143.813 89.1703 127.5 109.286 127.5H400.714C420.83 127.5 437.143 143.813 437.143 163.929V179.98Z",
    fill: "#FCFCFD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M437.143 346.071C437.143 366.187 420.83 382.5 400.714 382.5H109.286C89.1703 382.5 72.8571 366.187 72.8571 346.071V220.734L230.525 299.591C238.266 303.382 246.576 305.317 255 305.317C263.424 305.317 271.791 303.395 279.441 299.572L437.143 220.734V346.071Z",
    fill: "#FCFCFD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/envelope.b64c1031bd35d78e8461fc5a1a85e31a.svg";
export { ForwardRef as ReactComponent };